export default "__VITE_ASSET__CbNmXYLQ__"